import { EventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter';
import { ISubscribableService } from '@src/slide/application/service/subscribable-service/subscribable-service.interface';
import { EventMap } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';

/**
 * 提供订阅能力的Service基类，其本质是一个EventEmitter
 * 继承SubscribableService的子Service，需要定义自己的EventMap，来提供支持注册的事件类型
 */
export class SubscribableService<E extends EventMap> extends EventEmitter<E> implements ISubscribableService<E> {}

